/*
 * @Author: Lina
 * @Date: 2020-04-15 10:48:41
 * @LastEditTime: 2020-07-27 17:36:39
 * @LastEditors: Lina
 * @Description: In User Settings Edit
 * @FilePath: /FE-DSTemplate/src/services/api.js
 */
import request from '../utils/request';
import { userAuthorUrl, activityUrl, blockVideo, movieDailyCoupon,apiConfig } from './apiConfig';
import jsonpAdapter from "axios-jsonp";
import hotelApi from './hotelApi';
// 获取验证码
export function getVerifycode(data) {
  return request(`${userAuthorUrl}/getVerifycode`, data);
}

// 登录
// export function reg(data) {
//   return request(`${userAuthorUrl}/reg`, data);
// }
export function reg(data) {
  return request(`${activityUrl}/prizeGrant/activity/${window._activityKey}/login`, data, { withoutLogin: true });
}

// 推广用户登录记录渠道
export const regWithChannel = (data) => request(`${userAuthorUrl}/recommendReg`, data)

// 获取礼包
export function getCoupon() {
  return request(`${activityUrl}/activity/getCoupon`, { activityKey: window._activityKey });
}

// 分享获礼包
export function getShareCoupon() {
  return request(`${activityUrl}/prizeGrant/activity/getShareCoupon`, { activityKey: window._activityKey });
}

// 已登录获礼包
export function loggedCoupon(data) {
  return request(`${activityUrl}/prizeGrant/activity/${window._activityKey}/logged`, data);
}

// 查询领券状态
export function queryActStatus(data) {
  return request(`${activityUrl}/prizeGrant/activity/${window._activityKey}/query/status`, data);
}

// 视频宣发活动接口
// 获取活动状态
export function videoActivityStatus(){
  return request(`${blockVideo}/activity/info`, { activityKey: window._activityKey }, {showLoading: false, withoutLogin: true})
}

// 获取用户信息
export function videoSubjectInfo(){
  return request(`${blockVideo}/subject/info`, { activityKey: window._activityKey }, {showLoading: false})
}
// 观看视频得抽奖机会
export function videoWatch(){
  return request(`${blockVideo}/subject/watchVideo`, { activityKey: window._activityKey }, {showLoading: false})
}
// 分享得抽奖机会
export function videoShare(){
  return request(`${blockVideo}/subject/share`, { activityKey: window._activityKey }, {showLoading: false})
}
// 抽奖
export function videoDraw(){
  return request(`${blockVideo}/subject/draw`, { activityKey: window._activityKey }, {showLoading: true})
}
// 我的中奖记录
export function videoPrizeRecord(){
  return request(`${blockVideo}/prizeRecord/info`, { activityKey: window._activityKey }, {showLoading: false})
}


// 视频娱乐发券: https://api-manager.ccrgt.com/doc/2tEIgeiL1N
// 获取券列表
export function getMovieDailyCoupons(){
  return request(`${movieDailyCoupon}/info`, { activityKey: window._activityKey}, {showLoading: true})
}
// 点击领取券
export function grantMovieDailyCoupon(data){
  return request(`${movieDailyCoupon}/grantCoupon`, {...data, activityKey: window._activityKey}, {showLoading: true})
}


// 获取当情设备经纬度
export function getLocation() {
  return window.crgt.axios({
  url: 'https://apis.map.qq.com/ws/location/v1/ip?key=PUSBZ-L6IA3-6O63J-YGV44-PHOWS-2XFA4&output=jsonp',
  adapter: jsonpAdapter,
})
}

export default{
  movieDailyCouponService: {
    getMovieDailyCoupons: getMovieDailyCoupons,
    grantMovieDailyCoupon: grantMovieDailyCoupon
  },
  wxDiscountCard: {
    cardInfo: cardInfo
  },
  
}

function cardInfo(data){
  return request(`${apiConfig.selectApiHost(apiConfig.wxDiscountCard)}/enjoyCard/intoEnjoyCardHtml`, data, {showLoading: true} )
}
